import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { web } from "../../lib/api";

const STYLE = {
  gold: { color: "#F5C542", frame: "linear-gradient(135deg, #FFF1B8, #C8961E 28%, #FFE27A 50%, #8A5E0B 74%, #FFE9A6)", label: "Gold edition" },
  platinum: { color: "#E5E7EB", frame: "linear-gradient(135deg, #FFFFFF, #94A3B8 26%, #F1F5F9 46%, #64748B 70%, #E2E8F0 88%, #BAE6FD)", label: "Platinum edition" },
};

/** One-time pop-up for coaches when this player's card moved up to Gold or Platinum. */
export const EditionAlert = ({ tid, pid, onOpenCard }) => {
  const [alert, setAlert] = useState(null);
  useEffect(() => {
    let live = true;
    web.get(`/teams/${tid}/players/${pid}/edition-alert`)
      .then(({ data }) => { if (live && STYLE[data?.alert?.tier]) setAlert(data.alert); })
      .catch(() => {});
    return () => { live = false; };
  }, [tid, pid]);
  const close = (openCard) => {
    if (alert) web.post(`/teams/${tid}/edition-alerts/${alert.id}/seen`).catch(() => {});
    setAlert(null);
    if (openCard) onOpenCard();
  };
  const s = STYLE[alert?.tier];
  return (
    <Dialog open={!!alert} onOpenChange={(o) => { if (!o) close(false); }}>
      {s && (
        <DialogContent data-testid="edition-alert-dialog" className="max-w-sm overflow-hidden border-[#1E293B] bg-[#0A0E1A] p-0 text-white">
          <div className="h-2 w-full" style={{ background: s.frame }} />
          <div className="space-y-4 p-6">
            <span className="flex h-14 w-14 items-center justify-center rounded-full" style={{ background: s.frame }}><Trophy className="h-7 w-7 text-[#0A0E1A]" /></span>
            <DialogTitle data-testid="edition-alert-title" className="font-display text-3xl font-black uppercase leading-none" style={{ color: s.color }}>{s.label} unlocked</DialogTitle>
            <DialogDescription className="text-base text-slate-300">
              {alert.player_name ?? "This player"}'s trading card moved up on a standout season: <b data-testid="edition-alert-reason" style={{ color: s.color }}>{alert.reason}</b>. The team, the player and their parents got a celebration email.
            </DialogDescription>
            <div className="flex flex-wrap gap-2 pt-1">
              <button data-testid="edition-alert-open-card" onClick={() => close(true)} className="rounded-full px-5 py-2.5 text-sm font-bold text-[#0A0E1A] transition-transform hover:-translate-y-0.5" style={{ background: s.frame }}>Open the card</button>
              <button data-testid="edition-alert-dismiss" onClick={() => close(false)} className="rounded-full border border-[#1E293B] px-5 py-2.5 text-sm font-semibold text-slate-200 transition-colors hover:text-white">Nice!</button>
            </div>
          </div>
        </DialogContent>
      )}
    </Dialog>
  );
};
